import Vue from 'vue';
export default new Vue();

export const VIDEO_ACTION = {
  REJECT: 'video_reject'
};
